import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { NgbAccordionDirective } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { StyleCodeGroup } from '../../new-order-item-custom-qty-date.component';

@Component({
    selector: 'app-new-order-item-grouped-by-style-code',
    templateUrl: './new-order-item-grouped-by-style-code.component.html',
    styleUrls: ['./new-order-item-grouped-by-style-code.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewOrderItemGroupedByStyleCodeComponent implements AfterViewInit, OnDestroy {

  @ViewChild('OuterAccordion') outerAccordion: NgbAccordionDirective;

  @Input() groups: StyleCodeGroup[];
  @Input() orderItemsFormCustomDate: FormArray;
  @Input() supportsSplitDelivery: boolean;
  @Input() showStockQty: boolean;
  @Input() maxStoreCustomDate: string;
  @Input() componentId: string;
  @Input() expandCollapse$: Subject<'expand' | 'collapse'>;

  @Output() dateAdded = new EventEmitter<{ orderItemIndex: number; customDate?: string }>();
  @Output() stockDateAdded = new EventEmitter<number>();
  @Output() customDateCleared = new EventEmitter<number>();
  @Output() dateRemoved = new EventEmitter<{ orderItemIndex: number; customDateIndex: number }>();
  @Output() dateTimeChanged = new EventEmitter<{ ev: string; form: AbstractControl }>();

  private sub = new Subscription();

  ngAfterViewInit() {
    if (this.expandCollapse$) {
      this.sub.add(this.expandCollapse$.subscribe(action => {
        action === 'expand' ? this.outerAccordion.expandAll() : this.outerAccordion.collapseAll();
      }));
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getItemForm(itemIndex: number): FormGroup {
    return this.orderItemsFormCustomDate.controls[itemIndex] as FormGroup;
  }

  areAllGroupItemsSelected(itemIndexes: number[]): boolean {
    return itemIndexes.length > 0 && itemIndexes.every(i =>
      !!(this.orderItemsFormCustomDate.controls[i] as FormGroup).get('isChecked')?.value
    );
  }

  onToggleGroupSelectAll(itemIndexes: number[], event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    itemIndexes.forEach(i => {
      (this.orderItemsFormCustomDate.controls[i] as FormGroup).get('isChecked').setValue(checked);
    });
  }

  isSingleDate(minDate: string, maxDate: string): boolean {
    return minDate?.split('T')[0] === maxDate?.split('T')[0];
  }

  trackByProductCode(index: number, group: StyleCodeGroup): string {
    return group.productCode;
  }
}
